import axios from 'axios';
import httpClient from '../httpClient';
import store from 'redux/configureStore';
const FileDownload = require('js-file-download');


export const switchToOrganizationAccount = () => {
    return httpClient
        .get('/api/v2/account/reorganize_account')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const changeOrganizationName = (params) => {
    return httpClient
        .patch('/api/v2/account/name_update', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const changeSocialMediaSettings = () => {
    return httpClient
        .get('/api/v2/account/change_social_media_mail_settings')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};



// export const getCombinedCsvReport = (id) => {
//     return httpClient
//         .get(`/api/v2/account/std_statistics`)
//         .then((res) => {
//             console.log(res.data)
//             console.log(res.headers['content-disposition'])
//             let headerLine = res.headers['content-disposition'];
//             let name = headerLine.substring(headerLine.indexOf('=') + 1, headerLine.indexOf('.csv') + 4);
//             console.log(name)
//             console.log(headerLine)
//             FileDownload(res.data, `${name ? name : 'entity-statistics.csv'}`);
//         })
//         .catch((e) => {
//             throw e.response.data.content;
//         });
// };
